'use strict';

/**
 * Created by stapletont on 05/01/2015.
 */

define('app', ['controlTower', 'element', 'ajax', 'animation', 'urlApi', 'urlReader', 'utils',
// Script that are not used within this file but are required
'polyfill'], function (controlTower, Element, ajax, animation, urlApi, urlReader, utils) {

  var element = new Element();

  return {

    select: function select() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return element.init.apply(element, args);
    },

    subscribe: controlTower.subscribe,

    publish: controlTower.publish,

    clear: controlTower.clear,

    controlTower: controlTower,

    ajax: ajax,

    element: element,

    on: element.on.bind(element),

    animation: animation,

    urlApi: urlApi,

    urlReader: urlReader,

    utils: utils,

    /**
     * Return list of methods available within an object
     * @returns {object}
     */
    listFunctions: function listFunctions() {
      return this;
    }
  };
});
//# sourceMappingURL=app-esl.js.map
